import './pvdsSharedSingletons';
import { componentFactory } from '@dovetail/core/initialization';
import { ProjectConstructorConfig } from '@dovetail/core/types';

const exportableComponents: Record<string, () => Promise<unknown>> = {
  Ensemble: () =>
    import(/* webpackChunkName: "EnsembleApp" */ './app/EnsembleApp'),
  EnsembleStandalone: () =>
    import(
      /* webpackChunkName: "EnsembleStandalone" */ './screens/EnsembleStandaloneScreen'
    ),
  EnsembleAdmin: () =>
    import(/* webpackChunkName: "EnsembleAdmin" */ './app/EnsembleAdmin'),
};

export default class Ensemble {
  components: Record<string, ReturnType<typeof componentFactory>>;
  constructor(readonly config: ProjectConstructorConfig) {
    this.config = config;
    this.components = Object.keys(exportableComponents).reduce(
      (accumulator, componentName) => ({
        ...accumulator,
        [componentName]: componentFactory(
          exportableComponents[componentName],
          this.config
        ),
      }),
      {}
    );
  }
}
